(function () {
  'use strict';

  var SESSION_KEY = 'kvlr-popup';
  var KLAVIYO_LIST_ID = 'YgQDBU';
  var KLAVIYO_COMPANY_ID = 'Trmxjk';

  /* ─── Klaviyo subscribe ───────────────────────────────────── */
  function subscribeToKlaviyo(email, onSuccess, onError) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    })
    .then(function(res) {
      if (res.ok || res.status === 202) {
        onSuccess();
      } else {
        onError();
      }
    })
    .catch(function() {
      onError();
    });
  }

  /* ─── Show / hide ─────────────────────────────────────────── */
  function showPopup() {
    var popup = document.getElementById('kvlr-popup');
    if (!popup) return;
    popup.removeAttribute('aria-hidden');
    popup.classList.add('kvlr-popup--visible');
  }

  function closePopup() {
    var popup = document.getElementById('kvlr-popup');
    if (!popup) return;
    popup.classList.remove('kvlr-popup--visible');
    popup.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  /* ─── Screen transition ───────────────────────────────────── */
  function switchToSuccess() {
    var s1 = document.querySelector('.kvlr-popup__screen--1');
    var s2 = document.querySelector('.kvlr-popup__screen--2');
    if (!s1 || !s2) return;

    s1.style.opacity = '0';
    setTimeout(function () {
      s1.setAttribute('hidden', '');
      s2.removeAttribute('hidden');
      s2.style.opacity = '0';
      void s2.offsetWidth;
      s2.style.transition = 'opacity 0.4s ease';
      s2.style.opacity = '1';
    }, 350);
  }

  /* ─── Init ────────────────────────────────────────────────── */
  function initPopup() {
    if (sessionStorage.getItem(SESSION_KEY)) return;

    function scheduleShow() {
      setTimeout(showPopup, 2000);
    }

    if (document.documentElement.classList.contains('kvlr-loaded')) {
      scheduleShow();
      return;
    }

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.classList.contains('kvlr-loaded')) {
          obs.disconnect();
          scheduleShow();
          return;
        }
      }
    });

    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* ─── Wire up events after DOM ready ─────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initPopup();

    var closeBtn = document.querySelector('.kvlr-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    var overlay = document.querySelector('.kvlr-popup__overlay');
    if (overlay) overlay.addEventListener('click', closePopup);

    var form = document.querySelector('.kvlr-popup__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = form.querySelector('.kvlr-popup__input');
        var email = input ? input.value.trim() : '';
        if (!email) return;

        var btn = form.querySelector('.kvlr-popup__btn');
        if (btn) btn.disabled = true;

        subscribeToKlaviyo(
          email,
          function() {
            sessionStorage.setItem(SESSION_KEY, '1');
            switchToSuccess();
          },
          function() {
            if (btn) btn.disabled = false;
            if (input) input.style.borderColor = 'red';
          }
        );
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var popup = document.getElementById('kvlr-popup');
      if (popup && popup.classList.contains('kvlr-popup--visible')) {
        closePopup();
      }
    });
  });
})();

